export function dataURLtoFile(dataUrl, filename) {
  let arr = dataUrl.split(','),
  mime = arr[0].match(/:(.*?);/)[1],
  bStr = atob(arr[1]),
  n = bStr.length,
  u8arr = new Uint8Array(n);
  while(n--) u8arr[n] = bStr.charCodeAt(n);
  return new File([u8arr], filename, { type: mime });
}
